module.exports = __webpack_public_path__ + "img/output_8.acc13abf.png";